<template>
    <section id="payment-types">
        <div class="row">
            <div class="col-sm-12 blackBar"><div class="title">Payment type</div></div>
        </div>
        <div class="row backgroundGray">
            <div class="col-sm-6">
                <div class="checkbox">
                    <label>
                        <input type="radio" name="payment" value="4" checked>
                        <span>Invoice</span>
                    </label>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  
}
</script>
